'use client';

import { Phone } from 'lucide-react';
import { cn } from '@/core/utils/cn';

interface QueueStatusBadgeProps {
  ringingCount: number;
  queueDepth: number;
  className?: string;
}

export function QueueStatusBadge({
  ringingCount,
  queueDepth,
  className,
}: QueueStatusBadgeProps) {
  const total = ringingCount + queueDepth;
  if (total === 0) return null;

  return (
    <div
      id="calls_queue_badge"
      className={cn(
        'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium',
        ringingCount > 0
          ? 'bg-hms-red/10 text-hms-red'
          : 'bg-hms-amber/10 text-hms-amber',
        className
      )}
    >
      <Phone className="w-3 h-3" />
      {ringingCount > 0 && (
        <span>{ringingCount} ringing</span>
      )}
      {queueDepth > 0 && (
        <span>{queueDepth} queued</span>
      )}
    </div>
  );
}
